@if(!previewOnly) {
  <div class="row">
    @if (campaign) {
    <div class="col-12">
      @if(!previewOnly) { 
        @if(showFullMessage) {
          <div class="border rounded-3 p-2 overflow-auto mb-3">
            <div class="row">
              <h4 class="modal-title mb-3">{{ 'shared.buttonZapi.messageOptions' | translate }}</h4>

              <div class="row" [formGroup]="formGroup">
                <div class="col-xs-12 mb-3">
                  <label class="form-label">{{ 'shared.buttonZapi.titleOptional' | translate }}</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="title"
                    [placeholder]="'shared.buttonZapi.titlePlaceholder' | translate"
                  />
                </div>
                <div class="col-xs-12 mb-3">
                  <label class="form-label">{{ 'shared.buttonZapi.messageRequired' | translate }}</label>
                  <textarea
                    class="form-control mb-1"
                    formControlName="message"
                    [placeholder]="'shared.buttonZapi.messagePlaceholder' | translate"
                    rows="4"
                    maxlength="1200"
                  ></textarea>
                  <field-error-component
                    [field]="'message'"
                    [label]="'shared.buttonZapi.messageLabel' | translate"
                    [formGroup]="formGroup"
                  >
                  </field-error-component>
                </div>
                <div class="col-xs-12 mb-3">
                  <label class="form-label">{{ 'shared.buttonZapi.footerOptional' | translate }}</label>
                  <input
                    class="form-control mb-1"
                    formControlName="footer"
                    [placeholder]="'shared.buttonZapi.footerPlaceholder' | translate"
                  />
                </div>
              </div>
            </div>
          </div>
        }

        <div class="border rounded-3 p-2 overflow-auto">
          <div class="row">
            <div class="col-xs-12 mb-1">
              <label class="form-label">{{ 'shared.buttonZapi.buttonsMax' | translate:{ max: maxButtons } }}</label>

              @for(buttonControl of buttonActionsArray.controls; track $index) {
                <div class="border rounded-3 p-2 mb-1">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h5 class="modal-title">{{ 'shared.buttonZapi.buttonNumber' | translate:{ number: $index + 1 } }}</h5>

                    @if(buttonActionsArray.length > 1) {
                      <button
                        type="button"
                        class="btn btn-link p-0 ms-2"
                        (click)="removeButtonAction($index)"
                      >
                        <i class="mdi mdi-trash-can-outline fs-4 text-danger"></i>
                      </button>
                    }
                  </div>

                  <div class="mb-2" [formGroup]="getButtonGroup($index)">
                    <label class="form-label">{{ 'shared.buttonZapi.buttonType' | translate }}</label>
                    <div class="d-flex flex-wrap gap-4">
                      <div class="form-check form-check-inline form-radio-info">
                        <input
                          type="radio"
                          class="form-check-input"
                          formControlName="type"
                          [value]="ButtonActionsTypeEnum.reply"
                          [id]="'reply-' + $index"
                        />
                        <label class="form-check-label" [for]="'reply-' + $index">
                          {{ 'shared.buttonZapi.typeReply' | translate }}
                        </label>
                      </div>

                      <div class="form-check form-check-inline form-radio-info">
                        <input
                          type="radio"
                          class="form-check-input"
                          formControlName="type"
                          [value]="ButtonActionsTypeEnum.call"
                          [id]="'call-' + $index"
                        />
                        <label class="form-check-label" [for]="'call-' + $index">
                          {{ 'shared.buttonZapi.typeCall' | translate }}
                        </label>
                      </div>

                      <div class="form-check form-check-inline form-radio-info">
                        <input
                          type="radio"
                          class="form-check-input"
                          formControlName="type"
                          [value]="ButtonActionsTypeEnum.url"
                          [id]="'url-' + $index"
                        />
                        <label class="form-check-label" [for]="'url-' + $index">
                          {{ 'shared.buttonZapi.typeLink' | translate }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="mb-2" [formGroup]="getButtonGroup($index)">
                    <label class="form-label">{{ 'shared.buttonZapi.buttonTextRequired' | translate }}</label>
                    <input
                      type="text"
                      formControlName="label"
                      class="form-control"
                      [placeholder]="'shared.buttonZapi.buttonTextPlaceholder' | translate"
                    />
                    <field-error-component
                      [field]="'label'"
                      [label]="'shared.buttonZapi.buttonTextLabel' | translate"
                      [formGroup]="getButtonGroup($index)"
                    >
                    </field-error-component>
                  </div>

                  @if(getButtonGroup($index).get('type')?.value === ButtonActionsTypeEnum.url) {
                    <div class="mb-2" [formGroup]="getButtonGroup($index)">
                      <label class="form-label">{{ 'shared.buttonZapi.buttonUrlRequired' | translate }}</label>
                      <input
                        type="text"
                        formControlName="url"
                        class="form-control"
                        [placeholder]="'shared.buttonZapi.buttonUrlPlaceholder' | translate"
                      />
                      <field-error-component
                        [field]="'url'"
                        [label]="'shared.buttonZapi.buttonUrlLabel' | translate"
                        [formGroup]="getButtonGroup($index)"
                      >
                      </field-error-component>
                    </div>
                  } @if(getButtonGroup($index).get('type').value === ButtonActionsTypeEnum.call) {
                    <div class="mb-2" [formGroup]="getButtonGroup($index)">
                      <label class="form-label">{{ 'shared.buttonZapi.phoneNumberRequired' | translate }}</label>
                      <input
                        type="text"
                        formControlName="phone"
                        class="form-control"
                        [placeholder]="'shared.buttonZapi.phoneNumberPlaceholder' | translate"
                      />
                      <field-error-component
                        [field]="'phone'"
                        [label]="'shared.buttonZapi.phoneNumberLabel' | translate"
                        [formGroup]="getButtonGroup($index)"
                      >
                      </field-error-component>
                    </div>
                  }
                </div>
              }
            </div>

            @if(buttonActionsArray.length < maxButtons) {
              <div class="w-100">
                <button
                  type="button"
                  class="btn btn-primary w-100"
                  (click)="addButtonAction()"
                >
                  {{ 'shared.buttonZapi.addButton' | translate }}
                </button>
              </div>
            } @else if (buttonActionsArray.length >= maxButtons) {
              <div role="alert">
                <span class="alert alert-warning d-block">
                  {{ 'shared.buttonZapi.maxButtonsAllowed' | translate:{ max: maxButtons } }}
                </span>
              </div>
            }
          </div>
        </div>
      }
    </div>
    } @else {
      <div class="col-6">
        @if(!previewOnly) { 
          @if(showFullMessage) {
            <div class="border rounded-3 p-2 overflow-auto mb-3">
              <div class="row">
                <h4 class="modal-title mb-3">{{ 'shared.buttonZapi.messageOptions' | translate }}</h4>
  
                <div class="row" [formGroup]="formGroup">
                  <div class="col-xs-12 mb-3">
                    <label class="form-label">{{ 'shared.buttonZapi.titleOptional' | translate }}</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="title"
                      [placeholder]="'shared.buttonZapi.titlePlaceholder' | translate"
                    />
                  </div>
                  <div class="col-xs-12 mb-3">
                    <label class="form-label">{{ 'shared.buttonZapi.messageRequired' | translate }}</label>
                    <textarea
                      class="form-control mb-1"
                      formControlName="message"
                      [placeholder]="'shared.buttonZapi.messagePlaceholder' | translate"
                      rows="4"
                      maxlength="1200"
                    ></textarea>
                    <field-error-component
                      [field]="'message'"
                      [label]="'shared.buttonZapi.messageLabel' | translate"
                      [formGroup]="formGroup"
                    >
                    </field-error-component>
                  </div>
                  <div class="col-xs-12 mb-3">
                    <label class="form-label">{{ 'shared.buttonZapi.footerOptional' | translate }}</label>
                    <input
                      class="form-control mb-1"
                      formControlName="footer"
                      [placeholder]="'shared.buttonZapi.footerPlaceholder' | translate"
                    />
                  </div>
                </div>
              </div>
            </div>
          }
  
          <div class="border rounded-3 p-2 overflow-auto">
            <div class="row">
              <div class="col-xs-12 mb-1">
                <label class="form-label">{{ 'shared.buttonZapi.buttonsMax' | translate:{ max: maxButtons } }}</label>
  
                @for(buttonControl of buttonActionsArray.controls; track $index) {
                  <div class="border rounded-3 p-2 mb-1">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <h5 class="modal-title">{{ 'shared.buttonZapi.buttonNumber' | translate:{ number: $index + 1 } }}</h5>
  
                      @if(buttonActionsArray.length > 1) {
                        <button
                          type="button"
                          class="btn btn-link p-0 ms-2"
                          (click)="removeButtonAction($index)"
                        >
                          <i class="mdi mdi-trash-can-outline fs-4 text-danger"></i>
                        </button>
                      }
                    </div>
  
                    <div class="mb-2" [formGroup]="getButtonGroup($index)">
                      <label class="form-label">{{ 'shared.buttonZapi.buttonType' | translate }}</label>
                      <div class="d-flex flex-wrap gap-4">
                        <div class="form-check form-check-inline form-radio-info">
                          <input
                            type="radio"
                            class="form-check-input"
                            formControlName="type"
                            [value]="ButtonActionsTypeEnum.reply"
                            [id]="'reply-' + $index"
                          />
                          <label class="form-check-label" [for]="'reply-' + $index">
                            {{ 'shared.buttonZapi.typeReply' | translate }}
                          </label>
                        </div>
  
                        <div class="form-check form-check-inline form-radio-info">
                          <input
                            type="radio"
                            class="form-check-input"
                            formControlName="type"
                            [value]="ButtonActionsTypeEnum.call"
                            [id]="'call-' + $index"
                          />
                          <label class="form-check-label" [for]="'call-' + $index">
                            {{ 'shared.buttonZapi.typeCall' | translate }}
                          </label>
                        </div>
  
                        <div class="form-check form-check-inline form-radio-info">
                          <input
                            type="radio"
                            class="form-check-input"
                            formControlName="type"
                            [value]="ButtonActionsTypeEnum.url"
                            [id]="'url-' + $index"
                          />
                          <label class="form-check-label" [for]="'url-' + $index">
                            {{ 'shared.buttonZapi.typeLink' | translate }}
                          </label>
                        </div>
                      </div>
                    </div>
  
                    <div class="mb-2" [formGroup]="getButtonGroup($index)">
                      <label class="form-label">{{ 'shared.buttonZapi.buttonTextRequired' | translate }}</label>
                      <input
                        type="text"
                        formControlName="label"
                        class="form-control"
                        [placeholder]="'shared.buttonZapi.buttonTextPlaceholder' | translate"
                      />
                      <field-error-component
                        [field]="'label'"
                        [label]="'shared.buttonZapi.buttonTextLabel' | translate"
                        [formGroup]="getButtonGroup($index)"
                      >
                      </field-error-component>
                    </div>
  
                    @if(getButtonGroup($index).get('type')?.value === ButtonActionsTypeEnum.url) {
                      <div class="mb-2" [formGroup]="getButtonGroup($index)">
                        <label class="form-label">{{ 'shared.buttonZapi.buttonUrlRequired' | translate }}</label>
                        <input
                          type="text"
                          formControlName="url"
                          class="form-control"
                          [placeholder]="'shared.buttonZapi.buttonUrlPlaceholder' | translate"
                        />
                        <field-error-component
                          [field]="'url'"
                          [label]="'shared.buttonZapi.buttonUrlLabel' | translate"
                          [formGroup]="getButtonGroup($index)"
                        >
                        </field-error-component>
                      </div>
                    } @if(getButtonGroup($index).get('type').value === ButtonActionsTypeEnum.call) {
                      <div class="mb-2" [formGroup]="getButtonGroup($index)">
                        <label class="form-label">{{ 'shared.buttonZapi.phoneNumberRequired' | translate }}</label>
                        <input
                          type="text"
                          formControlName="phone"
                          class="form-control"
                          [placeholder]="'shared.buttonZapi.phoneNumberPlaceholder' | translate"
                        />
                        <field-error-component
                          [field]="'phone'"
                          [label]="'shared.buttonZapi.phoneNumberLabel' | translate"
                          [formGroup]="getButtonGroup($index)"
                        >
                        </field-error-component>
                      </div>
                    }
                  </div>
                }
              </div>
  
              @if(buttonActionsArray.length < maxButtons) {
                <div class="w-100">
                  <button
                    type="button"
                    class="btn btn-primary w-100"
                    (click)="addButtonAction()"
                  >
                    {{ 'shared.buttonZapi.addButton' | translate }}
                  </button>
                </div>
              } @else if (buttonActionsArray.length >= maxButtons) {
                <div role="alert">
                  <span class="alert alert-warning d-block">
                    {{ 'shared.buttonZapi.maxButtonsAllowed' | translate:{ max: maxButtons } }}
                  </span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if(!campaign) {
      <div class="col-6">
        <chat-wa-preview
          [title]="title"
          [message]="message"
          [footer]="footer"
          [buttons]="buttonsForDisplay"
          [templateType]="'button'"
        />
      </div>
    }
  </div>
}

@if(previewOnly) {
  <div role="dialog" aria-labelledby="modalPreviewButtons" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="modalPreviewButtons">
            {{ 'shared.buttonZapi.previewButtons' | translate }}
            <br>
            <span class="text-muted fw-normal font-14">{{ 'shared.buttonZapi.previewDescription' | translate }}</span>
          </h4>
          <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>
        </div>
        <div class="modal-body custom-scroll-bar">
          <chat-wa-preview
            [title]="title"
            [message]="message"
            [footer]="footer"
            [buttons]="buttonsForDisplay"
            [templateType]="'button'"
          />
        </div>

        @if(showConfirmButton) {
          <div class="modal-footer">
            <button
              (click)="cancel()"
              class="btn btn-light"
            >
              {{ 'shared.buttonZapi.close' | translate }}
            </button>
            <button
              (click)="confirm()"
              class="btn btn-primary"
            >
              {{ 'shared.buttonZapi.sendMessage' | translate }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}

    

    
    
  
